import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import tranImg from "./../components/images/Transactions.svg";
import { getTransaction, refundTransaction, getGBussinessInfo, sendReceiptMail, numbermessage, clearsessions, getInvoicehtmlcontent, getPlans, logEvent, updateTransactionPaymentMode } from "../services/apiServices";
import Popup from "../components/Popup";
import Payments from "../views/Payments";
import ReceiptPrint from "../views/ReicptPrint";
import PaymentModeEditPOS from "./PaymentModeEditPOS";

import { format, parseISO } from "date-fns";
import moment from 'moment-timezone';
import {
  MDBBtn,
  MDBRadio,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBCheckbox,
  MDBInput,
  MDBIcon,
  MDBDatatable
} from 'mdb-react-ui-kit';
import logo from "../components/images/Easy-MembrLogo.png";
import Loader from "../components/Loader";
import { formatDate } from '../utils/DateFormat';
import { browserName, browserVersion } from "react-device-detect";
import MemberDuepayment from "../memberportal/components/MemberDuepayment";
import { BasePlanName } from "../utils/BasePlanName";
import { useAnalytics } from "../hooks/useAnalytics";

const MULTIPLE_AMOUNT_KEYS = [
  { key: "cash_amt", label: "cash_amt" },
  { key: "cc_amt", label: "cc_amt" },
  { key: "upi_amt", label: "upi_amt" },
  { key: "wallet_amt", label: "wallet_amt" },
];

function getMultipleSplitSummaryLines(payinfoStr) {
  try {
    const p = typeof payinfoStr === "string" ? JSON.parse(payinfoStr) : payinfoStr;
    const inf = p?.info;
    if (!inf || typeof inf !== "object") return [];
    const lines = [];
    MULTIPLE_AMOUNT_KEYS.forEach(({ key, label }) => {
      const v = parseFloat(inf[key]);
      if (v && !Number.isNaN(v)) {
        lines.push(`${label} ₹${v}`);
      }
    });
    return lines;
  } catch (e) {
    return [];
  }
}

function getPaymentModeLabel(mode, payinfoStr) {
  if (mode === 1) return "Cash";
  if (mode === 2) return "Card";
  if (mode === 3) return "UPI";
  if (mode === 4) return "Wallet";
  if (mode === 5) return "Coupon";
  if (mode === -2) return "Payment Link";
  if (mode === -3) return "Razorpay";
  if (mode === 6) {
    const lines = getMultipleSplitSummaryLines(payinfoStr);
    return lines.length ? lines.join(" · ") : "Multiple";
  }
  if (mode >= 7) {
    try {
      const p = typeof payinfoStr === "string" ? JSON.parse(payinfoStr) : payinfoStr;
      if (p?.info?.userpaymethod) return p.info.userpaymethod;
    } catch (e) {
      /* ignore */
    }
    return `Account type (${mode})`;
  }
  return "—";
}

export default function Footer(props) {
  let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
  const navigate = useNavigate();
  const { trackButtonClick } = useAnalytics();
  const [openPayment, setOpenPayment] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [tData, setTData] = useState("");
  const [mem, setmem] = useState("");
  const [loading, setLoading] = useState(true)
  const [transDate, setTransDate] = useState(new Date())
  const [smessage, setSMessage] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);
  const [refundContent, setRefundContent] = useState(false);
  const [percentrefund, setpercentrefund] = useState(1);
  const [refundvalue, setRefundvalue] = useState(0);
  const [refundreason, setRefundreason] = useState("");
  const [errr, seterrr] = useState("");
  const [busData, setBusdata] = useState("");
  const [userdata, setUserdata] = useState([])
  const [groupd, setGroupd] = useState("");
  const [DueTrans, setDueTrans] = useState(false);
  const [Rtoken, setRtoken] = useState(true);
  const [mailData, setMailData] = useState([])
  const [selectedEmails, setSelectedEmails] = useState(mailData || []);
  const [OtherData, setOtherData] = useState("")
  const [invoiceUrl, setInvoiceUrl] = useState("");
  const [numberData, setNumberData] = useState([])
  const [selectedNumbers, setSelectedNumbers] = useState(numberData || []);
  const [selectType, setSelectType] = useState("email")
  const logourl = localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : logo) : logo;
  const [imageLoaded, setImageLoaded] = useState(true);
  const [clearSess, setClearSess] = useState(null);
  const [apiError, setApiError] = useState(false);
  const [rowPaymentModeModal, setRowPaymentModeModal] = useState(null);
  const [rowModeError, setRowModeError] = useState("");
  const [savingRowPaymentMode, setSavingRowPaymentMode] = useState(false);

  const dateeee = tData[0]?.createdAt;
  console.log(busData, 'busData');
  const adminTimeZone = busData?.timezone?.value || "Asia/Kolkata";

  const isCurrentMonthTransaction = dateeee
    ? moment.tz(dateeee, adminTimeZone).month() === moment.tz(adminTimeZone).month() &&
    moment.tz(dateeee, adminTimeZone).year() === moment.tz(adminTimeZone).year()
    : false;
  console.log(isCurrentMonthTransaction, 'isCurrentMonthTransaction');

  console.log(!refundContent,
    Rtoken,
    isCurrentMonthTransaction, tData, 'test');

  const [plans, setPlans] = useState("");
  useEffect(() => {
    async function fetchPlans() {
      try {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
        const planResponse = await getPlans(loggedUser.gymid);

        if (!planResponse || planResponse === "false") {
          setApiError(true);
        } else {
          const plans = await planResponse.json();
          if (plans) {
            setPlans(plans);
          }
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
        setApiError(true);
      }
    }

    fetchPlans();
  }, []);

  useEffect(() => {

    const handleImageLoad = () => {
      setImageLoaded(true);
    };

    const handleImageError = () => {
      setImageLoaded(false);
    };
    const imgElement = document.createElement("img");
    imgElement.onload = handleImageLoad;
    imgElement.onerror = handleImageError;
    imgElement.src = logourl;

    return () => {
      imgElement.onload = null;
      imgElement.onerror = null;
    };
  }, [logourl]);
  console.log(props);
  useEffect(() => {
    async function fetchData(id, _id) {
      // console.log(id, (props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid), props?.token);

      const response = await getTransaction(id, (props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid), props?.token);
      if (!response) {

        return;
      }
      const record = await response.json();
      if (!record || record.length === 0) {
        navigate("/");
        return;
      }

      setInvoiceUrl(record.length > 0 ? record[0].url : "")
      setUserdata(record)
      console.log(record);
      setTData([record[0]]);
      if (record[0]?.payment.balance !== 0 || (record[0].paymenthistory && record[0].paymenthistory.length !== 1)) {
        setDueTrans(true);
      } else {
        setDueTrans(false);
      }
      setmem(record);
      const uniqueItemIds = new Set();
      const uniqueRecords = [];
      let updatedRecord = record.sort((a, b) => b.updatedAt - a.updatedAt);
      updatedRecord.forEach((reco) => {
        const { itemid } = reco;
        if (!uniqueItemIds.has(itemid)) {
          uniqueRecords.push(reco);
          uniqueItemIds.add(itemid);
        }
      });
      setGroupd(uniqueRecords);
      console.log(uniqueRecords);
      const res = await getGBussinessInfo((props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid));
      const rec = await res.json();
      setBusdata(rec);
      setLoading(false)

    }
    fetchData(props.id, props.transid);

    if (props.Rtoken) {
      setRtoken(false);
    }
  }, [navigate, props, clearSess]);

  async function processandReturn(event) {
    event.preventDefault();
    const billdata = [];

    const price = tData && tData[0].payment.totalamount;
    const discount = tData && tData[0].payment.discountpercent ? tData[0].payment.discountpercent : 0;
    const transactiond = tData && tData[0].tId;
    console.log(groupd);
    groupd && groupd.forEach((records, itemid) => {
      const itm = records;
      const hasPlan = itm.plan && typeof itm.plan === 'object' && Object.keys(itm.plan).length > 0;
      const isPlanArray = Array.isArray(itm.plan);
      const isAddonsArray = Array.isArray(itm.addons);
      const isSubPlanArray = Array.isArray(itm.subplan);


      const itemPrice =
        // (hasPlan && itm.plan.price) ? itm.plan.price :
        //   (isPlanArray && itm.plan.length > 0 && itm.plan[0].price) ? itm.plan[0].price :
        //     (isSubPlanArray && itm.subplan.length > 0 && itm.subplan[0].price) ? itm.subplan[0].price :
        //       (isAddonsArray && itm.addons.length > 0 && itm.addons[0].price) ? itm.addons[0].price :

        (itm.payment?.itemprice ? itm.payment.itemprice:0)

      // console.log("itemPricefor",
      //   (hasPlan && itm.plan.name) ||
      //   (isPlanArray && itm.plan[0]?.name) ||
      //   (isAddonsArray && itm.addons[0]?.name) ||
      //   "Unknown", ":", itemPrice);

      const discountValue = mem.filter(itmVal => itmVal.itemid === itm.itemid).reduce((memberAcc, member) => memberAcc + (member.payment.discount ? member.payment.discount.amount : 0), 0);

      const taxInculded = (hasPlan && itm.plan.taxcheck) ?
        (itm.plan.taxcheck === true ? "Included" : "Excluded") :
        (isPlanArray && itm.plan.length > 0 && itm.plan[0].taxcheck) ?
          (itm.plan[0].taxcheck === true ? "Included" : "Excluded") :
          (isAddonsArray && itm.addons.length > 0 && itm.addons[0].taxcheck === true ? "Included" : "Excluded");
      const taxPercentage = (itm.payment?.taxamounts && Array.isArray(itm.payment.taxamounts) && itm.payment.taxamounts.length > 0) ?
        (itm.payment.taxamounts.reduce((acc, obj) => acc + (obj.percentage ? (parseFloat(obj.percentage) / 100) : 0), 0)) : 0;

      const totalItemPrice = itemPrice * itm.quantity;
      const isTaxIncluded = itm.payment?.taxamounts && Array.isArray(itm.payment.taxamounts) && itm.payment.taxamounts.length > 0 &&
        (itm.payment.taxamounts.filter((obj) => obj?.TaxCheck === "Included").length > 0);

      console.log("totalItemPrice", totalItemPrice)
      const itemName = (hasPlan && itm.plan.name)
        ? itm.plan.name
        : (isPlanArray && itm.plan.length > 0 && itm.plan[0].name)
          ? itm.plan[0].name
          : (isSubPlanArray && itm.subplan.length > 0 && itm.subplan[0].name)
            ? `${BasePlanName(plans, itm.baseplanid)}-${itm.subplan[0].name}`
            : (isAddonsArray && itm.addons.length > 0 && itm.addons[0].name)
              ? itm.addons[0].name
              : "";
      billdata.push({
        sno: billdata.length + 1,
        name: itemName,
        qty: itm.quantity,
        price: totalItemPrice,
        check: isTaxIncluded,
        tax: busData.ugsttax && busData.ugsttax.filter(obj => obj.check).map(obj => parseFloat(obj.label)),
        taxd: busData && busData.dgsttax[0] === 1 ? "18" : 0,
        discount: discountValue,
        overAllTax: itm.payment?.taxamounts ? itm.payment.taxamounts : [{ TaxCheck: taxInculded }],
        cost: isTaxIncluded ?
          parseFloat((totalItemPrice / (1 + taxPercentage)).toFixed(2)) :
          totalItemPrice,
        discountper: mem.filter(itmVal => itmVal.itemid === itm.itemid).reduce((memberAcc, member) => {
          if (!member.payment?.discount) return memberAcc;

          const discount = member.payment.discount;
          if (discount.discountType === "percent") {
            return memberAcc + discount.EnterValue;
          } else {
            const hasIncludedTax = itm.payment?.taxamounts && Array.isArray(itm.payment.taxamounts) &&
              itm.payment.taxamounts.filter((obj) => obj?.TaxCheck == "Included").length > 0;

            const itemPriceBase = hasIncludedTax ?
              parseFloat(((itm.payment?.itemprice || 0) / (1 + taxPercentage)).toFixed(2)) :
              (itm.payment?.itemprice || 0);

            return memberAcc + ((discount.amount / itemPriceBase) * 100);
          }
        }, 0),
      });
    });
    console.log(billdata);
    const businessdetails = {
      businessname: tData && tData[0]?.businessdetails?.businessname || "",
      logourl: tData && tData[0]?.businessdetails?.logourl || "",
      address: tData && tData[0]?.businessdetails?.address || "",
      city: tData && tData[0]?.businessdetails?.city || "",
      state: tData && tData[0]?.businessdetails?.state || "",
      gstnumber: (tData && tData[0]?.businessdetails?.gst)
        || ((busData?.dgsttax?.length > 0 && busData.dgsttax[0] === 1) ? busData.gstnumber : ""),
      hsncode: ((tData && tData[0]?.businessdetails?.gst)
        || (busData?.dgsttax?.length > 0 && busData.dgsttax[0] === 1 && busData.gstnumber))
        ? (tData && tData[0]?.businessdetails?.hsncode ? tData[0].businessdetails.hsncode : "")
        : "",
      // ? tData[0]?.businessdetails.hsncode : (busData?.hsn?.check == true ? busData.hsn.value : ""),
    }
    console.log(businessdetails, '88888888888333333333');
    let userdetails = {
      name: businessdetails.businessname ? businessdetails.businessname : busData.firstName + " " + busData.lastName,
      number: busData.contactNumber,
      state: businessdetails.state ? businessdetails.state : busData.state,
      business: businessdetails.businessname ? businessdetails.businessname : busData.businessName,
      city: businessdetails.city ? businessdetails.city : busData.city,
      address: businessdetails.address ? businessdetails.address : busData.address,
      membername: tData.length > 0 ? ((tData[0].parentname != null && tData[0].parentname.name) ? tData[0].parentname.name : tData[0].members.fname + ' ' + tData[0].members.lname) : "",
      membernumber: (() => {
        const raw = tData.length > 0 ? ((tData[0].parentname != null && tData[0].parentname.mobile) ? tData[0].parentname.mobile : tData[0].members.number) : "";
        if (!raw) return raw;
        const s = raw.toString().trim();
        if (s.startsWith("+")) return s;
        const digits = s.replace(/\D/g, "");
        if (digits.length === 12 && digits.startsWith("91")) return "+" + digits;
        if (digits.length === 10) return "+91" + digits;
        return s;
      })(),
      memberaddress: tData?.length > 0 ? ((tData[0].parentname != null && tData[0].parentname && tData[0]?.parentname?.address) ? tData[0].parentname.address : tData[0].members.address) : "",
      membercity: tData[0].members.city,
      membercuntry: tData[0].members.country,
      invoice: parseFloat(busData._id) + format(new Date(), "MM"),
      gst: businessdetails.gstnumber ? businessdetails.gstnumber : "",
      clientgst: tData?.length > 0 ? (tData[0].parentname != null && tData[0].parentname?.gstin) ? tData[0].parentname?.gstin : "" : "",
      hsncode: businessdetails?.hsncode
    }
    console.log(userdetails);
    let taxdetails = busData;
    console.log(busData);
    let date = format(new Date(tData && tData[0]?.createdAt || new Date()), "dd-MM-yyyy");
    console.log(date);
    let payObj = {
      dueAmount: tData && tData[0]?.payment?.balance || 0,
      paidAmount: tData && tData[0]?.payment?.paid || 0,
      totalPrice: tData && tData[0]?.payment?.totalamount || 0,
    }
    console.log(billdata);
    const updates = {
      // logourl: logourl,
      logourl: businessdetails.logourl ? businessdetails.logourl : logourl,
      userdetails: userdetails,
      taxdetails: taxdetails,
      payObj: payObj,
      billdata: billdata,
      transactiond: transactiond,
      token: props?.token,
      totalPrice: payObj.totalPrice,
      date: date,
      timezone: adminTimeZone,
    }
    const htmlContent = await getInvoicehtmlcontent(updates, transactiond)
    if (htmlContent === "false") {
      setApiError(true)
      return
    }
    const record = await htmlContent.json();

    console.log(record, '9999999999999999999');

    // Open a new window.
    const print_area = window.open('', '_blank');
    print_area.document.write(record.htmlContent);
    print_area.document.close();
    print_area.focus();
    setTimeout(() => {

      print_area.print();
    }, 500);
  }

  function handleTransdate(date) {
    console.log("in transdetails handleTransDate", date);
    setTransDate(date)
  }
  async function Refundsubmit(id) {
    if (refundreason && refundvalue) {
      await trackButtonClick("Transactiondetails", "Transaction_Refund", props.path == "member" ? "member" : "staff", {});

      let remainingAmount = tData[0]?.payment.paid -
        (tData[0]?.refund && tData[0]?.refund.length > 0 ?
          tData[0]?.refund.reduce((acc, obj) => acc + obj.refundamount, 0) : 0);
      let percentageamount = percentrefund == 2 ?
        (remainingAmount * refundvalue / 100) : parseFloat(refundvalue);

      // let percentageamount = percentrefund == 2 ? (tData[0].payment.paid - (tData[0].refund && tData[0].refund.length > 0 ? tData[0].refund.reduce((acc, obj) => acc + obj.refundamount, 0) : 0) * refundvalue / 100) : refundvalue;
      let taxamt1 = (busData && busData.dgsttax[0] === 1 ? (Math.round((refundvalue * 1) * 0.18, 2)) : 0)
        + (busData.ugsttax ? busData.ugsttax.reduce((acc, obj) => acc + Math.round((refundvalue * 1) * (parseFloat(obj.check ? obj.label : 0)) / 100), 0) : 0)
      let taxamt2 = (busData && busData.dgsttax[0] === 1 ? (Math.round((percentageamount * 1) * 0.18, 2)) : 0)
        + (busData.ugsttax ? busData.ugsttax.reduce((acc, obj) => acc + Math.round((percentageamount * 1) * (parseFloat(obj.check ? obj.label : 0)) / 100), 0) : 0)
      let taxamt = (busData && busData.dgsttax[0] === 1 ? (Math.round((percentageamount * 1) * 0.18, 2)) : 0)
        + (busData.ugsttax ? busData.ugsttax.reduce((acc, obj) => acc + Math.round((percentageamount * 1) * (parseFloat(obj.check ? obj.label : 0)) / 100), 0) : 0);
      let refund = {
        // taxamt: percentrefund == 2 ? taxamt2 : taxamt1,
        taxamt: taxamt,
        resultamt: percentrefund == 2 ? refundvalue + "%" : refundvalue,
        refundamount: percentageamount,
        reason: refundreason,
        percentrefund: percentrefund,
      }
      let newid = Math.random().toString().substring(2, 8);
      let updates = {
        refund: refund,
        members: mem,
        id: id,
        newid: newid,
      }
      console.log(updates);
      let resp = await refundTransaction(updates, id);
      let value = resp.json()
      if (resp.ok) {
        console.log("Refund Success:", value);

        let ip = localStorage.getItem("ipaddress");
        let browserinfo = browserName + "-" + browserVersion + ".0.0";
        let Eventtype = "Membership";
        let username1 = localStorage.getItem("loggedUserInfo")
          ? JSON.parse(localStorage.getItem("loggedUserInfo")).email
          : "";

        let gymid = (props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);

        let memberNames = Array.isArray(mem)
          ? mem.map((m) => {
            let fname = m?.members?.fname?.trim() || "";
            let lname = m?.members?.lname?.trim() || "";
            let fullName = (fname + " " + lname).trim();
            return fullName || "Unnamed";
          }).join(", ")
          : "Unknown Member";

        let flag = `Refund of ₹${percentageamount} issued to ${memberNames} `;
        func();

        await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);

      }

    }
    else {
      seterrr("Fields cannot be empty");
    }
  }
  const func = () => {
    props.oncancel()
    window.location.reload(true);
  }
  const [memberpay, setMemberpay] = useState(false)
  const [memberSelItem, setMemberSelItem] = useState(null)
  function payNow() {
    let tId = tData[0] ? tData[0].tId : 0;
    let balanceamt = tData[0] ? tData[0].payment.balance : 0;
    let totalPrice = tData[0] ? tData[0].payment.totalamount : 0;
    let selItems = groupd.map((item) => {
      // let membership = item.plan.length > 0 ? item.plan[0] : (item.addons.length > 0 ? item.addons[0] : [])
      const plansArray = item.plan || [];
      const addonsArray = item.addons || [];
      const subplansArray = item.subplan || [];

      // Priority: plan > addons > subplan
      let membership = {};
      if (plansArray.length > 0) {
        membership = plansArray[0];
      } else if (addonsArray.length > 0) {
        membership = addonsArray[0];
      } else if (subplansArray.length > 0) {
        membership = subplansArray[0];
      }


      const taxIncluded = membership.taxcheck === true ? "Included" : "Excluded"
      // const taxamounts = item.payment.taxamounts ? item.payment.taxamounts : [{ TaxCheck: `${taxIncluded}` }];
      const taxamounts = item.payment.taxamounts ? item.payment.taxamounts : [{ TaxCheck: taxIncluded }];
      const linePrice =
        membership.price != null && membership.price !== ""
          ? membership.price
          : balanceamt;
      return {
        Item: { ...membership, price: linePrice },
        idate: item.startdate,
        isplan: 3,
        members: mem.filter((meme) => meme.itemid === item.itemid).map((obj) => obj.members).flat(),
        quantity: item.quantity,
        taxamounts: taxamounts,
        token: tData[0].token,
        _id: item.itemid,
        price: balanceamt,
        ref_tId: tId,
      };
    });
    if (props.from !== "member") {
      localStorage.setItem("transactionId", tId);
      localStorage.setItem(
        "allData",
        JSON.stringify({
          price: balanceamt,
          isplan: 3,
          ref_tId: tId,
          token: tData[0].token,
          totalPrice: totalPrice,
        })
      );
      localStorage.setItem(
        "selItems",
        JSON.stringify(selItems)
      );
      setOpenPayment(true);
    } else {
      setMemberSelItem(selItems)
      setMemberpay(true)

    }

  }
  function onPayemntDone(event) {
    setOpenReceipt(true);
  }
  function oncancelpayment() {
    setOpenPayment(false);
    setOpenReceipt(false);
  }
  function gotohome() {
    cancelThis();
  }

  function cancelThis(event) {
    clearAll();
  }

  function clearAll() {
    window.location.reload(true);
    setOpenPayment(false);
    setOpenReceipt(false);
  }

  async function clearSession(e, id) {

    console.log(id);
    setClearSess(null)
    await clearsessions(id)
    // setClearSess(null)
  }

  async function refreshTransactionAfterPaymentMode(gymId) {
    const response = await getTransaction(props.id, gymId, props?.token);
    if (!response) return false;
    const record = await response.json();
    if (record && record.length > 0) {
      setTData([record[0]]);
      setUserdata(record);
      if (record[0].payment.balance !== 0 || (record[0].paymenthistory && record[0].paymenthistory.length !== 1)) {
        setDueTrans(true);
      } else {
        setDueTrans(false);
      }
    }
    return true;
  }

  function openRowPaymentModeEdit(row, historyIndex) {
    setRowPaymentModeModal({
      sno: row.sno,
      historyIndex,
      originalMode: row.mode,
      originalPayinfo: row.payinfo,
      paidAmount: row.paid,
      transid: row.transid != null ? String(row.transid) : "",
    });
    setRowModeError("");
  }

  async function handlePaymentEditSave(result) {
    if (!rowPaymentModeModal || !tData?.[0] || !result) return;
    const gymId = props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    const payload = { transId: tData[0].tId, historyLineTransRef: result.transId };
    if (rowPaymentModeModal.sno != null && rowPaymentModeModal.sno !== undefined && rowPaymentModeModal.sno !== "") {
      payload.historySno = Number(rowPaymentModeModal.sno);
    }
    if (rowPaymentModeModal.historyIndex != null && rowPaymentModeModal.historyIndex !== undefined) {
      payload.historyIndex = rowPaymentModeModal.historyIndex;
    }
    if (result.type === "multiple") {
      payload.updateMultipleSplit = true;
      payload.multipleInfo = result.multipleInfo;
    } else {
      payload.newMode = result.newMode;
      if (result.couponInfo) payload.couponInfo = result.couponInfo;
      if (result.customInfo) payload.customInfo = result.customInfo;
    }
    setSavingRowPaymentMode(true);
    setRowModeError("");
    try {
      const res = await updateTransactionPaymentMode(gymId, payload);
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        setRowModeError(body.message || "Could not update payment mode");
        return;
      }
      await refreshTransactionAfterPaymentMode(gymId);
      setRowPaymentModeModal(null);
    } catch (err) {
      console.error(err);
      setRowModeError("Could not update payment mode");
    } finally {
      setSavingRowPaymentMode(false);
    }
  }


  function handleClik(data) {
    if (props.filters == "mdetails") {
      props.oncancel()

    } else {

      let selMember = data.members

      localStorage.setItem("transaction_filter1", JSON.stringify(props.filters))
      selMember.Date11 = null;
      selMember.Date22 = null;
      selMember.TType = 3;
      selMember.addon = [];
      selMember.address = data.members && data.members.address ? data.members.address : "";
      selMember.age = data.members.age || "";
      selMember.anotherColumn = null;
      selMember.bId = data.members.bId;
      selMember.bloodgroup = data.members.bloodgroup || "";
      selMember.city = data.members.city || "";
      selMember.country = data.members.country || "";
      selMember.createdAt = data.members.createdAt;
      selMember.email = data.members.email || "";
      selMember.expirydate = data.members.expirydate;
      selMember.fname = data.members && data.members.fname;
      selMember.height = data.members && data.members.height ? data.members.height : null;
      selMember.lname = data.members && data.members.lname;
      selMember.mid = data.members.mid;
      selMember.member = data.members.member || "";
      selMember.number = data.members.number;
      selMember.others = data.members.others || "";
      selMember.plan = data.plan || [];
      selMember.planid = data.members.planid;
      selMember.referral = data.members.referral;
      selMember.sex = data.members.sex;
      selMember.startdate = data.members.startdate;
      selMember.updatedAt = data.members.updatedAt;
      selMember.weight = data.members.weight || null;
      selMember.__v = 0;
      selMember._id = data.members._id;
      selMember.return = "transactions"

      console.log(selMember);
      navigate("/mdetails", {
        state: selMember,
      });
    }
  }
  let tmrow = [];
  mem && mem.forEach((itm) => {
    let rarray = [];
    rarray.push(itm.members && (<div className="link-color" onClick={() => handleClik(itm)}>{itm.members.fname + " " + itm.members.lname}</div>));

    if (itm.subplan && itm.subplan.length > 0) {
      // subplan case → baseplan - subplan
      const baseName = BasePlanName(plans, itm.subplan[0].baseplan);
      rarray.push(baseName ? `${baseName} - ${itm.subplan[0].name}` : itm.subplan[0].name);
    } else if (itm.plan) {
      // normal plan
      rarray.push(itm.plan.name);
    } else if (itm.addons && itm.addons.length > 0) {
      // addon case
      rarray.push(itm.addons[0].name);
    } else {
      rarray.push("");
    }




    rarray.push(
      formatDate(itm.expirydate).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
      })
    );
    rarray.push(<div className="d-flex align-items-center justify-content-between"><span>{itm.session.length > 0 ? itm.session[0].balsessions : "--"}</span>{itm.session.length > 0 && itm.session[0].balsessions < 0 && <MDBBtn size="sm" className="ms-2" onClick={(e) => setClearSess(itm.session[0]._id)}>Clear</MDBBtn>}</div>)
    tmrow.push(rarray);
  });
  ///**Refund paymentt**//////////
  let tmrowr = [];
  tData && tData.length > 0 && tData[0] && tData[0].refund && tData[0].refund.forEach((itm) => {
    let rarray = [];
    rarray.push(itm.token);
    rarray.push(itm.reason);
    rarray.push(
      formatDate(itm.date).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
      })
    );
    rarray.push("₹ " + itm.refundamount);
    tmrowr.push(rarray);
  });
  let newRow = [' ', ' ', 'Total ', "₹ " + (tData && tData.length > 0 && tData[0].refund ? tData[0].refund.reduce((acc, obj) => acc + obj.refundamount, 0) : 0)];
  tmrowr.push(newRow);
  ////**Paid amount — MDBDatatable (stopPropagation on mode cell for edit button)**//////////
  const transRaw =
    tData && tData.length > 0 && tData[0].paymenthistory
      ? tData[0].paymenthistory.map((row, idx) => ({ ...row, _phIndex: idx }))
      : [];
  const transDataSorted = [...transRaw].sort((a, b) => (b.sno || 0) - (a.sno || 0));
  let tmrowD = [];
  transDataSorted.forEach((itm) => {
    const historyIndex = itm._phIndex;
    const row = { ...itm };
    delete row._phIndex;
    const multiLines =
      Number(row.mode) === 6 ? getMultipleSplitSummaryLines(row.payinfo) : null;
    const modeCell = (
      <div
        className="d-flex align-items-center justify-content-between gap-2 flex-wrap"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        {multiLines != null ? (
          <div className="text-start">
            {multiLines.length === 0 ? (
              <span>Multiple</span>
            ) : (
              multiLines.map((line, li) => <div key={li}>{line}</div>)
            )}
          </div>
        ) : (
          <span>{getPaymentModeLabel(row.mode, row.payinfo)}</span>
        )}
        {props.from !== "member" && (
          <button
            type="button"
            className="btn btn-link btn-sm p-0 border-0 text-decoration-none d-inline-flex align-items-center"
            title="Edit payment mode"
            aria-label="Edit payment mode"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              openRowPaymentModeEdit(row, historyIndex);
            }}
          >
            <MDBIcon far icon="edit" className="link-color" />
          </button>
        )}
      </div>
    );
    tmrowD.push([
      formatDate(row.date).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
      }),
      "₹ " + row.paid,
      row.transid || "—",
      modeCell,
    ]);
  });
  tmrowD.push([
    "Total Paid",
    "",
    "",
    "₹ " + (tData && tData[0].payment.paid),
  ]);
  tmrowD.push([
    <div key="due-label" className="d-inline">
      <span className="fw-600">Total Due</span>
      {tData && tData[0].payment.balance > 0 &&
        (props.from !== "member" ? (
          <label
            className="link-color ms-2 mb-0"
            style={{ cursor: "pointer" }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              payNow();
            }}
          >
            Pay Now
          </label>
        ) : (
          <span className="ms-2 d-inline-block">
            <MemberDuepayment
              groupd={groupd}
              trans={tData && tData.length > 0 ? tData[0] : {}}
              mem={mem}
              SuccessCallback={props.SuccessCallback}
            />
          </span>
        ))}
    </div>,
    "",
    "",
    "₹ " + (tData && tData[0].payment.balance),
  ]);
  const basicDataD = {
    columns: [
      { label: "Date", field: "token", sort: false },
      { label: "Amount", field: "amount", sort: false },
      { label: "Trans ID", field: "tid", sort: false },
      { label: "Mode", field: "pmode", sort: false },
    ],
    rows: tmrowD,
  };
  const basicData = {
    columns:
      [
        { label: "Members", field: "members", sort: false },
        { label: "Plan/Addon", field: "planaddon", sort: false },
        { label: "Expire Date", field: "expiredate", sort: false },
        { label: "Session Remaining", field: "sessionremaining", sort: false }
      ],
    rows: tmrow,
  };
  const basicDataR = {
    columns: [
      { label: "Token", field: "token", sort: false },
      { label: "Reason", field: "reason", sort: false },
      { label: "Date", field: "date", sort: false },
      { label: "Amount", field: "amount", sort: false }
    ],
    rows: tmrowr,
  };
  const handleCheckboxEmailChange = (email) => {
    setSelectedEmails((prevSelectedEmails) => {
      if (prevSelectedEmails.includes(email)) {
        return prevSelectedEmails.filter((selectedEmail) => selectedEmail !== email);
      } else {
        return [...prevSelectedEmails, email];
      }
    });
  };
  const handleCheckboxNumberChange = (number) => {
    setSelectedNumbers((prevSelectedNumbers) => {
      if (prevSelectedNumbers.includes(number)) {
        return prevSelectedNumbers.filter((selectedNumber) => selectedNumber !== number);
      } else {
        return [...prevSelectedNumbers, number];
      }
    });
  };


  const handlesendReceipt = (e) => {
    e.preventDefault();
    // const uniqueEmailAddresses = ["tvamshif@gmail.com", "vamshibuss99@gmail.com"];
    console.log(userdata);
    trackButtonClick("Transactiondetails", "Transaction_Receipt", props.path == "member" ? "member" : "staff", {});
    const uniqueEmailsSet = new Set();
    const uniqueNumbersSet = new Set()
    userdata.forEach(item => {
      console.log(item, 'item.member');

      if (item.member && item.member.email) {
        uniqueEmailsSet.add(item.member.email);
      }
      if (item.member && item.members.number) {
        uniqueNumbersSet.add(item.members.number)
      }

    });
    console.log(uniqueEmailsSet, 'uniqueEmailsSet');

    const uniqueEmailAddresses = Array.from(uniqueEmailsSet);
    // uniqueEmailAddresses.push(localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo"))).email : "")
    const uniqueNumbers = Array.from(uniqueNumbersSet);
    // uniqueNumbers.push(localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo"))).number : "")
    console.log(uniqueEmailAddresses, '88888');
    setMailData(uniqueEmailAddresses)
    setSelectedEmails(uniqueEmailAddresses)
    setNumberData(uniqueNumbers)
    setSelectedNumbers(uniqueNumbers)
    toggleOpen()
  }




  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhoneNumber = (mobileNumber) => {
    // const mobileRegex = /^\d{10}$/;
    const mobileRegex = /^(?:(?:\+|0{0,2})91(\s*|[-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
    //6856438922
    //7856128945
    //8945562713
    //9998564723
    //+91-9883443344
    //09883443344
    //919883443344
    //0919883443344
    //+919883443344
    //+91-9883443344
    //0091-9883443344
    //+91 9883443344
    //+91-785-612-8945
    //+91 999 856 4723
    return mobileRegex.test(mobileNumber);
  };

  const sendReceipt = async (e) => {
    e.preventDefault();

    console.log(selectedEmails);
    console.log(selectedNumbers);
    console.log("OtherMails", OtherData);

    const uniqueEmailsSet = new Set([...selectedEmails]);
    const uniqueNumbersSet = new Set([...selectedNumbers]);

    const otherDataArray = OtherData.split(',').map(data => data.trim());
    let response = "";
    if (selectType === "email") {
      otherDataArray.forEach(email => uniqueEmailsSet.add(email));
      otherDataArray.forEach(email => {
        if (isValidEmail(email)) {
          uniqueEmailsSet.add(email);
        } else {
          console.log(`Invalid email format: ${email}`);
        }
      });
      uniqueEmailsSet.forEach(email => {
        if (!isValidEmail(email)) {
          uniqueEmailsSet.delete(email);
        }
      });
      setMailData(Array.from(uniqueEmailsSet));

      // const content = recinf && recinf.length > 0 ? (recinf.length > 0 && recinf[0].Content) : "<p>Hello there<strong>!</strong> Below is the receipt for your most recent transaction. Please click on the download receipt button for the receipt. Feel free to click on the \"Download Receipt\" button to obtain your receipt. Appreciate your business!</p>"
      // console.log(content);

      const logo = localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : "") : "";

      console.log(logo, invoiceUrl, '77777777777777777777777777');
      if (Array.from(uniqueEmailsSet).length == 0) {
        return
      }
      let saverep = await sendReceiptMail(props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, Array.from(uniqueEmailsSet), invoiceUrl, (logo ? logo : ""), props?.token
      );
      // console.log(saverep);

      const responseData = await saverep.json();
      response = responseData.sendEmail
      console.log(responseData);
      console.log("email sent successfully ");
    } else {
      const number = "6281619099"
      otherDataArray.forEach(number => uniqueNumbersSet.add(number));
      otherDataArray.forEach(number => {
        if (isValidPhoneNumber(number)) {
          uniqueNumbersSet.add(number);
        } else {
          console.log(`Invalid number format: ${number}`);
        }
      });
      uniqueNumbersSet.forEach(number => {
        if (!isValidPhoneNumber(number)) {
          uniqueNumbersSet.delete(number);
        }
      });
      setNumberData(Array.from(uniqueNumbersSet));
      const respon = await numbermessage({ phone: number, url: invoiceUrl });
      console.log(respon);
      let resData = await respon.json();
      console.log(resData);
      response = resData.message
      console.log("sms sent successfully ");
    }
    toggleOpen()

    if (response === "success") {
      setSMessage(true);
      setTimeout(() => {
        setSMessage(false);
      }, 5000);
    }
    else {
      setSMessage(false);
    }
  };

  console.log(transDate, 'transdate');
  return (
    <>
      {loading && (<h4><Loader /></h4>)}
      <div>
        <div className="gym-container" id="showcase">
          {smessage && (
            <div>
              {/* <Toast message={smessage} /> */}

              <div id="snackbar-submit" className={`show-submit alert ${selectType === 'email' ? (mailData && mailData.length > 0 ? "alert-success" : "alert-danger") : (numberData && numberData.length > 0 ? "alert-success" : "alert-danger")} alert-fixed SentMailAllert w-30 mob-w-100`}>

                <div className="text-left">
                  {selectType === 'email' ? (mailData && mailData.length > 0 ? "Email sent successfully!!" : "Email not sent sentsuccessfully!! ") : (numberData && numberData.length > 0 ? "Sms sent successfully" : "Sms not sent successfully")}
                  <div>
                    {selectType === 'email' ? " Email(s):" : "Moblie Number(s):"}
                  </div>
                  <div>
                    {selectType === 'email' && (mailData && mailData.length > 0 ? (
                      <span>{mailData.join(', ')}</span>
                    ) : (
                      <span>No emails available</span>
                    ))}
                    {selectType === 'number' && (numberData && numberData.length > 0 ? (
                      <span>{numberData.join(', ')}</span>
                    ) : (
                      <span>No number available</span>
                    ))}

                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
        <div>
          {tData.length > 0 &&
            tData.map((item, index) => (
              <>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Date</p>
                  <p className="mb-1 fw-600">{formatDate(item.createdAt)}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Transactions ID</p>
                  <p className="mb-1 fw-600">{item.tId}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Token Number</p>
                  <p className={!Rtoken ? "mb-1 link-color fw-600" : "mb-1 fw-600"}
                    onClick={() => { setRtoken(true); }}
                  >
                    <p className="mb-1 fw-600">{item.token}</p>
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Quantity</p>
                  <p className="mb-1 fw-600 d-flex align-items-center"><MDBIcon far icon="user" className="me-1  fs-10" />{mem.length} </p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Total</p>
                  <p className="mb-1 fw-600">
                    <img src={tranImg} alt="totalamount" width="10" className="me-1" />
                    {item.payment.totalamount}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Tax</p>
                  <p className="mb-1 fw-600">
                    <img src={tranImg} alt="amount" width="10" className="me-1" />
                    {groupd && groupd.length > 0 ? (groupd.reduce((acc, obj) =>
                      acc + (obj.payment.taxamounts ? (obj.payment.taxamounts.reduce((innerAcc, val) =>
                        innerAcc + (val.amount ? val.amount : 0), 0)) : 0), 0)) : 0
                    }
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Paid</p>
                  <p className="mb-1 fw-600">
                    <img src={tranImg} alt="paid" width="10" className="me-1" />
                    {item.payment.paid}
                  </p>
                </div>
                
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-1">Due  {" "}
                    <span>{item && (item.payment.balance > 0 ?
                      (props.from !== "member" ? <>
                        <label className="link-color" onClick={(e) => { item && (item.payment.balance > 0 && payNow()) }}
                        >Pay Now</label></>
                        : <> <MemberDuepayment groupd={groupd} trans={tData && tData.length > 0 ? tData[0] : {}} mem={mem} SuccessCallback={props.SuccessCallback} /></>)
                      : <></>
                    )
                    }</span></p>
                  <p className="mb-1 fw-600" >
                    <img src={tranImg} alt="balance" width="10" className="me-1" />
                    {item.payment.balance}
                  </p>

                </div >
                {!DueTrans
                  && <div className="d-flex align-items-center justify-content-between">
                    <p> TransID</p>
                    <p className="mb-1 fw-600">
                      {tData && tData[0].paymenthistory?.[0].transid}
                    </p>
                  </div>}
                <p className="mb-1">Member(s):</p>


                <MDBDatatable data={basicData} className="Transaction__table sortOff" entries={25} />

                {(DueTrans ||
                  (props.from !== "member" && (tData[0].paymenthistory?.length || 0) > 0)) && (
                  <>
                    <p className="my-1">Paid Amount:</p>
                    <MDBDatatable data={basicDataD} className="Transaction__table" entries={25} />
                  </>
                )}
                {item.refund && item.refund.length > 0 &&
                  <>
                    <p className="my-1">Refund:</p>
                    <MDBDatatable data={basicDataR} className="Transaction__table" />
                  </>}
                {!refundContent &&
                  item.payment.paid > 0 &&
                  (item.payment.paid > (item.refund && item.refund.length > 0
                    ? item.refund.reduce((acc, obj) => acc + obj.refundamount, 0)
                    : 0)) &&
                  isCurrentMonthTransaction && props.from !== "member" && (
                    <p className="link-color my-1" onClick={() => setRefundContent((val) => !val)}>
                      Refund Amount
                    </p>
                  )}
                {refundContent &&
                  <>
                    <div className="d-flex align-items-center justify-content-between mt-3 mb-1">
                      <p className="my-1">Refund Amount</p>
                      <p className="w-70 text-end mb-1">
                        <big className="d-flex text-end justify-content-end">
                          <select className="gym-input form-select form-control w-40 height_37" onChange={(e) => { setpercentrefund(e.target.value); setRefundvalue(e.target.value === 2 ? "0" : ""); }} value={percentrefund}>
                            <option value={1}>Amount</option>
                            <option value={2}>Percentage</option>
                          </select>
                          {percentrefund !== 2 ?
                            <input
                              type="text"
                              className={(errr !== '' && refundvalue === '') ? "w-30 ms-2 form-control is-invalid" : "w-30 ms-2 form-control"}
                              placeholder={percentrefund == 2 ? "0%" : "0/-"}

                              value={refundvalue}
                              onInput={(e) => {
                                const inputValue = parseFloat(e.target.value);
                                const paidAmount = tData && tData[0].payment.paid - (item.refund && item.refund.length > 0 ? item.refund.reduce((acc, obj) => acc + obj.refundamount, 0) : 0);
                                if (inputValue >= paidAmount) {
                                  e.target.value = paidAmount;
                                  setRefundvalue(paidAmount);
                                }
                              }}
                              onChange={(e) => {

                                const numericValue = e.target.value.replace(/[^0-9.]/g, '');


                                let val = parseFloat(numericValue);


                                if (isNaN(val)) {
                                  setRefundvalue('');
                                  return;
                                }
                                const paidAmount = tData && tData[0].payment.paid;
                                // Apply limits
                                if (val > (percentrefund == 2 ? 100 : paidAmount)) {
                                  val = percentrefund == 2 ? 100 : paidAmount;
                                }
                                if (val < 0) val = 0;

                                // Remove leading zeros and set the value
                                setRefundvalue(val.toString().replace(/^0+(?=\d)/, ''));
                              }}
                            /> :
                            <input
                              type="number"
                              pattern="[0-9]*\.?[0-9]*"
                              className={(errr !== '' && refundvalue === '') ? "w-30 ms-2 form-control is-invalid" : "w-30 ms-2 form-control"}
                              placeholder="0%"
                              value={refundvalue}
                              onChange={(e) => {
                                let val = parseFloat(e.target.value);
                                if (val > 100) val = 100;
                                if (val < 0) val = 0;
                                setRefundvalue(val.toString());
                              }}
                            />}
                        </big></p>
                    </div>
                    <label>Refund Reason:</label>
                    <textarea type="text" rows={2} className={errr !== '' && refundreason === '' ? 'form-control is-invalid mb-1' : 'form-control'}
                      placeholder="Enter reason for refund" onChange={(e) => setRefundreason(e.target.value)}
                    ></textarea>

                    <div className="ms-1" style={{ color: "red" }}>{errr}</div>
                  </>}



                {refundContent && (
                  <p
                    className="link-color my-1"
                    onClick={() => { setRefundContent((val) => !val); seterrr("") }}
                    style={{ cursor: "pointer" }}
                  >
                    Clear Refund
                  </p>
                )}
              </>
            ))}
        </div>
      </div>
      <div className="modal-footer w-100">

        <p className="fs-small w-100  text-left">Note: All transactions are secure and encrypted</p>
        <div className="w-100 d-flex justify-content-between">
          <div>
            {props.from !== "member" && (plansInfo !== null && plansInfo?.feature?.gstreceipts) &&
              <button type="button" className="btn btn-primary float-start me-2" member-mdb-dismiss="modal" onClick={(e) => processandReturn(e)}>
                Print Receipt
              </button>}
            {props.from !== "member" && (plansInfo !== null && plansInfo?.feature?.emailreceipt) &&
              <button type="button" className="btn btn-primary float-start" member-mdb-dismiss="modal" onClick={(e) => handlesendReceipt(e)}>
                Send Receipt
              </button>}
            {props.from == "member" && <button type="button" className="btn btn-primary float-start me-2" member-mdb-dismiss="modal" onClick={() => props.downloadInvoice("membership")}>
              Download Invoice
            </button>}

          </div>
          {refundContent && <button type="button" className="btn btn-primary float-end" data-mdb-dismiss="modal" onClick={(e) => Refundsubmit(tData[0].tId)}>
            Refund
          </button>}

          <button type="button" className="btn btn-secondary float-end" data-mdb-dismiss="modal" onClick={props.oncancel}>
            Close
          </button>

        </div>



        {rowPaymentModeModal && (
          <PaymentModeEditPOS
            open={!!rowPaymentModeModal}
            onClose={() => {
              if (!savingRowPaymentMode) {
                setRowPaymentModeModal(null);
                setRowModeError("");
              }
            }}
            linePaid={rowPaymentModeModal.paidAmount}
            initialMode={rowPaymentModeModal.originalMode}
            initialPayinfoStr={
              typeof rowPaymentModeModal.originalPayinfo === "string"
                ? rowPaymentModeModal.originalPayinfo
                : rowPaymentModeModal.originalPayinfo
                  ? JSON.stringify(rowPaymentModeModal.originalPayinfo)
                  : ""
            }
            initialTransId={rowPaymentModeModal.transid ?? ""}
            gymId={props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid}
            saving={savingRowPaymentMode}
            serverError={rowModeError}
            onSave={handlePaymentEditSave}
          />
        )}

        <MDBModal show={basicModal} setShow={setBasicModal} open={basicModal} setOpen={setBasicModal} tabIndex='-1'>
          <MDBModalDialog>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Send Reciept</MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <div className="d-flex align-items-center mb-2">

                  <MDBRadio
                    name='inlineRadio'
                    id='inlineRadio1'
                    value='email'
                    label='Email'
                    inline
                    checked={selectType === 'email'}
                    onChange={() => {
                      setSelectType('email')
                      setOtherData("")
                    }}
                  />
                  {/* <MDBRadio
                    name='inlineRadio'
                    id='inlineRadio2'
                    value='number'
                    label='Phone Number'
                    inline
                    checked={selectType === 'number'}
                    onChange={() => {
                      setSelectType('number')
                      setOtherData("")
                    }}
                  /> */}
                </div>
                {selectType === 'email' && mailData && mailData.length > 0 && mailData.map((email, index) => (
                  <div key={index}>
                    {email && <MDBCheckbox
                      id={`flexCheckDefault${index}`}
                      label={email}
                      checked={selectedEmails.includes(email)}
                      onChange={() => handleCheckboxEmailChange(email)}
                    />}
                  </div>
                ))}
                {selectType === 'number' && numberData && numberData.length > 0 && numberData.map((number, index) => (
                  <div key={index}>
                    {number && <MDBCheckbox
                      id={`flexCheckDefault${index}`}
                      label={number}
                      checked={selectedNumbers.includes(number)}
                      onChange={() => handleCheckboxNumberChange(number)}
                    />}
                  </div>
                ))}
                <div className="mt-2">
                  <label>
                    Enter other {selectType === 'number' ? "number" : "email"}(s):
                  </label>
                  <MDBInput value={OtherData} onChange={(e) => setOtherData(e.target.value)} />
                  <p className="text-secondary m-0 mt-2">Note: To enter multiple {selectType === 'number' ? "number" : "email"}, use comma (,) separated values. </p>
                </div>
              </MDBModalBody>

              <MDBModalFooter className="pe-4 pb-3">
                <MDBBtn color='secondary' onClick={toggleOpen}>
                  Close
                </MDBBtn>
                <MDBBtn
                  // disabled={mailData.length > 0 ? false : true}
                  onClick={(e) => {
                    sendReceipt(e)
                  }}>Send</MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        {openPayment && (
          <Popup
            title="Payment Information"
            ptype="modal-lg"
            content={
              <>
                <div>
                  <Payments onsubmit={onPayemntDone} oncancel={oncancelpayment} handleTransdate={handleTransdate} />
                </div>
              </>
            }
            handleClose={oncancelpayment}
          />
        )}
        {openReceipt && (
          <Popup
            title="Print Receipt"
            ptype="modal-lg"
            content={
              <>
                <div>
                  <ReceiptPrint gotohome={gotohome} transactionDate={transDate} plansInfo={plans} />
                </div>
              </>
            }
            handleClose={gotohome}
          />
        )}
        {clearSess && (
          <Popup
            title="Confirm Clear"
            content={
              <>
                <div className="pb-3">
                  <span className="fs-6 pb-3">Are you sure you want to clear this session?</span>
                </div>
                <MDBModalFooter>
                  <MDBBtn color='secondary' onClick={(e) => setClearSess(null)}>
                    Cancel
                  </MDBBtn>
                  <MDBBtn color="danger" onClick={(e) => clearSession(e, clearSess)}>Clear</MDBBtn>
                </MDBModalFooter>
              </>
            }
            handleClose={setClearSess}
          />
        )}
      </div>
    </>
  );
}